import { render, staticRenderFns } from "./StepTerms.vue?vue&type=template&id=9d77aecc&scoped=true&"
import script from "./StepTerms.vue?vue&type=script&lang=ts&"
export * from "./StepTerms.vue?vue&type=script&lang=ts&"
import style0 from "./StepTerms.vue?vue&type=style&index=0&id=9d77aecc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d77aecc",
  null
  
)

export default component.exports